import { Eye, EyeOff } from "lucide-react";
import React, { useId, useState } from "react";

interface PayOSInputFieldProps {
  label: string;
  value: string;
  placeholder: string;
  isRequired: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
}

export const PayOSInputField: React.FC<PayOSInputFieldProps> = ({ label, value, placeholder, isRequired, onChange, name }) => {
  const id = useId();
  const [showPassword, setShowPassword] = useState(false);
  const Icon = showPassword ? EyeOff : Eye;

  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-4 md:items-center">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 md:col-span-1">
        {label} {isRequired && <span className="text-red-500">*</span>}
      </label>
      <div className="relative md:col-span-3">
        <input
          id={id}
          name={name}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
        />
        <button 
          type="button" 
          onMouseDown={() => setShowPassword(true)} 
          onMouseUp={() => setShowPassword(false)}
          onMouseLeave={() => setShowPassword(false)}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600" aria-label={`Toggle visibility for ${label}`}>
          <Icon size={18} />
        </button>
      </div>
    </div>
  );
};